<ada-container
	[colCount]="4"
	verticalSpacing="medium"
	horizontalSpacing="medium"
>
	<ada-alert
		*ngIf="validationMessage"
		type="error"
		[colSpan]="4"
		[title]="validationMessage"
		[isClosable]="false"
	></ada-alert>

	<!-- PART -->
	<ada-label
		content="Part"
		[isRequired]="!partIsDisabled"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-combo
		[isDisabled]="isDisabled || partIsDisabled"
		[options]="cpePartOptions"
		[placeholder]="partIsDisabled ? cpeInfo.part : ''"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[(value)]="cpeInfo.part"
	></ada-combo>

	<!-- Vendor -->
	<ada-label
		content="Vendor"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-input
		data-testid="cpe-info-editor-vendor-input"
		placeholder="Vendor"
		[debounce]="100"
		[isDisabled]="true"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="cpeInfo.vendor"
	></ada-input>

	<!-- Product -->
	<ada-label
		content="Product"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-input
		data-testid="cpe-info-editor-product-input"
		placeholder="Product"
		[debounce]="100"
		[isDisabled]="true"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="cpeInfo.product"
	></ada-input>
	
	<!-- Version -->
	<ada-label
		content="Version"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-input
		data-testid="cpe-info-editor-version-input"
		placeholder="Version"
		[debounce]="100"
		[isDisabled]="isDisabled"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="cpeInfo.version"
	></ada-input>

	<!-- Update -->
	<ada-label
		content="Update"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-input
		data-testid="cpe-info-editor-update-input"
		placeholder="Update"
		[debounce]="100"
		[isDisabled]="isDisabled"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="cpeInfo.update"
	></ada-input>
	
	<!-- Edition -->
	<ada-label
		content="Edition"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-input
		data-testid="cpe-info-editor-edition-input"
		placeholder="Edition"
		[debounce]="100"
		[isDisabled]="isDisabled"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="cpeInfo.edition"
	></ada-input>

	<!-- Language -->
	<ada-label
		content="Language"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-input
		data-testid="cpe-info-editor-language-input"
		placeholder="Language"
		[debounce]="100"
		[isDisabled]="isDisabled"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="cpeInfo.language"
	></ada-input>

	<!-- Swedition -->
	<ada-label
		content="Software Edition"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-input
		data-testid="cpe-info-editor-swedition-input"
		placeholder="Software Edition"
		[debounce]="100"
		[isDisabled]="isDisabled"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="cpeInfo.swEdition"
	></ada-input>

	<!-- Targetsw -->
	<ada-label
		content="Target Software"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-input
		data-testid="cpe-info-editor-targetsw-input"
		placeholder="Target Software"
		[debounce]="100"
		[isDisabled]="isDisabled"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="cpeInfo.targetSw"
	></ada-input>

	<!-- Targethw -->
	<ada-label
		content="Target Hardware"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-input
		data-testid="cpe-info-editor-targethw-input"
		placeholder="Target Hardware"
		[debounce]="100"
		[isDisabled]="isDisabled"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="cpeInfo.targetHw"
	></ada-input>

	<!-- Other -->
	<ada-label
		content="Other"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-label>
	<ada-input
		data-testid="cpe-info-editor-other-input"
		placeholder="Other"
		[debounce]="100"
		[isDisabled]="isDisabled"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="cpeInfo.other"
	></ada-input>
</ada-container>
